const RESOURCE_VENDOR_SECTION_REQUIRED_FIELDS: string[] = ['location', 'name'];

export default RESOURCE_VENDOR_SECTION_REQUIRED_FIELDS;
